import { configureStore } from "@reduxjs/toolkit";
import snackbarReducer from "./reducer/snackbarSlice";
import authUserReducer from "./reducer/authUserSlice";
import invoiceReducer from "./invoice/reducer/invoiceSlice";
import drawerReducer from "./reducer/drawerSlice";
import dialogReducer from "./reducer/dialogSlice";
import filterReducer from "./reducer/filterSlice";
import modalReducer from "./reducer/modalSlice";
import formReducer from "./reducer/DateAndEntityData/formSlice";
import breadcrumbReducer from "./reducer/DateAndEntityData/breadcrumbSlice";
import dateEntityReducer from "./reducer/DateAndEntityData/dateEntitySlice";
import itrFileSlice from "./reducer/itrFileSlice";
const store = configureStore({
    reducer: {
        snackbar: snackbarReducer,
        authUser: authUserReducer,
        drawer: drawerReducer,
        dialog: dialogReducer,
        filter: filterReducer,
        modal: modalReducer,
        entity: dateEntityReducer,
        form: formReducer,
        breadcrumb: breadcrumbReducer,
        invoice: invoiceReducer,
        itrFile: itrFileSlice,
    },
});

export type RootState = ReturnType<typeof store.getState>;

export default store;
